// =====================================================================
//  CONFIG POR EVENTO  —  esto es lo que "viste" el photobooth por campaña.
//  Animotion/la marca cambia textos, colores y el arte de personajes aquí.
//  Para usar el arte APROBADO: poné la ruta del PNG en "img"
//  (ej. "/personajes/drayk.png" dentro de /public/personajes/).
//  Si "img" queda vacío, se usa el personaje original de relleno (demo).
// =====================================================================

export type EntradaLado = "left" | "right" | "top" | "bottom";

export type Personaje = {
  nombre: string;       // llave del SVG de relleno (characters.ts) o solo etiqueta si usás img
  img?: string;         // ruta del PNG aprobado; vacío = usa el SVG de relleno
  leftPct: number;      // posición X en % de la pantalla
  topPct: number;       // posición Y en % de la pantalla
  widthPct: number;     // ancho en % de la pantalla
  entra: EntradaLado;   // desde dónde aparece al cuadro
};

export type BoothConfig = {
  campanaTitulo: [string, string];
  lockup: string;              // puede llevar <b></b> para resaltar
  colorPrimario: string;
  countdownSegundos: number;
  personajes: Personaje[];
  entrega: { whatsapp: boolean; qr: boolean };
  camara: { facingMode: "user" | "environment"; espejo: boolean };
};

export const CONFIG: BoothConfig = {
  campanaTitulo: ["LA FÁBRICA", "EMBRUJADA"],
  lockup: "FAN<b>T</b>A × McDonald’s",
  colorPrimario: "#f26722",
  countdownSegundos: 3,
  personajes: [
    { nombre: "fantasma",   img: "", leftPct: 4,  topPct: 30, widthPct: 20, entra: "left"   },
    { nombre: "calabaza",   img: "", leftPct: 6,  topPct: 58, widthPct: 24, entra: "bottom" },
    { nombre: "murcielago", img: "", leftPct: 74, topPct: 16, widthPct: 24, entra: "right"  },
  ],
  entrega: { whatsapp: true, qr: true },
  camara: { facingMode: "user", espejo: true },
};
